/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Order } from './order';

/**
 * Trade response
 */
export interface SyntheticTradeResponse {
  /**
   * Registered order with client.
   */
  registeredOrder: Order;
  /**
   * Hedge order ID for base asset.
   */
  hedgeOrderIdForBaseAsset: number;
  /**
   * Hedge order ID for quote asset.
   */
  hedgeOrderIdForQuoteAsset: number;
}
